import { Route, Routes } from "react-router-dom"
import DocumentList from "./components/DocumentList"

export default function DocumentsPage() {
  return (
    <Routes>
      <Route index element={<DocumentList />} />
    </Routes>
  )
}
